import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href", "target", "data-partno"]

import { PropType } from "vue";
import { ILink } from "@/models/ILink";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressLink',
  props: {
  link: {
    type: Object as PropType<ILink | null>,
    required: false,
  },
  className: {
    type: String,
    required: false,
  },
  sku: {
    type: String,
    required: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.link && __props.sku)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: __props.link.url,
        target: __props.link.target,
        class: _normalizeClass(__props.className),
        "data-partno": __props.sku
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 10, _hoisted_1))
    : _renderSlot(_ctx.$slots, "default", { key: 1 })
}
}

})